export function mapOrderPayment(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }

  const qrCode = String(raw.qr_code ?? '').trim()
  const amountRub = Number(raw.amount_rub)
  const amountVnd = Number(raw.amount_vnd)
  const exchangeRate = Number(raw.exchange_rate)

  return {
    status: String(raw.status ?? ''),
    provider: String(raw.provider ?? ''),
    amount: Number(raw.amount) || 0,
    amountRub: Number.isFinite(amountRub) ? amountRub : null,
    amountVnd: Number.isFinite(amountVnd) ? amountVnd : null,
    exchangeRate: Number.isFinite(exchangeRate) ? exchangeRate : null,
    currency: raw.currency != null ? String(raw.currency) : null,
    externalId: raw.external_id != null ? String(raw.external_id) : null,
    paymentUrl: String(raw.payment_url ?? '').trim() || null,
    qrCodeSvg:
      qrCode.startsWith('<svg') || qrCode.startsWith('<?xml') ? qrCode : null,
    mock: Boolean(raw.mock),
  }
}
